import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const SAMPLES_ENDPOINT = `${BASE_URL}/samples`;
export async function getAllSamplesData(queryParams) {
    try {
        const endpoint = queryParams ? `${SAMPLES_ENDPOINT}/?${queryParams}` : `${SAMPLES_ENDPOINT}/`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error fetching comments data:', error);
    }
};

export async function getSampleById(sample_id) {
    try {
        const response = await axios.get(`${SAMPLES_ENDPOINT}/${sample_id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching sample data:', error);
    }
};

export async function generateSampleExcel(sampleId) {
    try {
        const response = await axios.get(`${SAMPLES_ENDPOINT}/${sampleId}/generate_excel`,);
        return response.data
    } catch (error) {
        console.error('An error occured while generating the excel:', error);
    }
};